import { render, staticRenderFns } from "./PlayToken.vue?vue&type=template&id=424c4039&"
import script from "./PlayToken.vue?vue&type=script&lang=js&"
export * from "./PlayToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports